module.exports = __webpack_public_path__ + "fonts/Poppins-SemiBold.a36b89cf.woff2";